import { memo } from 'react';
import { ForgotPasswordConfirmTemplate } from 'components/templates/ForgotPasswordConfirmTemplate';

type Props = {};

export const ForgotPasswordConfirmPage = memo((_props: Props) => {
	return <ForgotPasswordConfirmTemplate />;
});
